import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import CatalogItem from 'rebook/apps/catalog/components/CatalogItem';
import NicheCatalog from 'rebook/apps/catalog/components/NicheCatalog';
import CatalogAbout from 'rebook/apps/catalog/components/CatalogAbout';
import * as CatalogIndexActions from 'rebook/apps/catalog/actions/CatalogIndexActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import { Niche } from 'rebook/apps/catalog/models';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';

import styles from './style.scss';


const NicheItem = ({ niche }) => {
  const theNiche = new Niche(niche);

  return (
    <li className={styles.item}>
      <Link to={theNiche.getLink()} className={styles.card}>
        <CatalogItem
          imageSrc={niche.image}
          count={get(niche, 'counters.books', 0)}>
          <div className="title-3">{niche.name}</div>
        </CatalogItem>
      </Link>
    </li>
  );
};

const NicheList = ({ niches }) => (
  <div className={styles.container}>
    <div className="sectionHeader">
      <h1>Жанры</h1>
    </div>
    <ul className={styles.list}>
      {niches && niches.length > 0 && (
        niches.map((item) => (
          <NicheItem niche={item} key={item.id} />
        ))
      )}
    </ul>
  </div>
);

class CatalogIndexView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldShowNicheList: false,
    };
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(CatalogIndexActions.fetchInitialData(match));
  }

  componentDidMount() {
    this.props.CatalogIndexActions.fetchInitialData();
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  showNicheList() {
    this.setState({ shouldShowNicheList: true });
  }

  showCatalog() {
    this.setState({ shouldShowNicheList: false });
  }

  render() {
    const {
      niches,
      bestsellersBookset,
      latestBooksets,
      audiobooks,
      latestBestAuthors,
      latestBookTags,
    } = this.props.catalogIndex;
    const { booksPerSubscriptionCounter } = this.props;
    const { shouldShowNicheList } = this.state;
    return (
      <div className="backgroundContainer themeGrey">
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Библиотека', url: get(this, 'props.location', '/catalog/') },
          ]} />
          {shouldShowNicheList
            ? (
              <React.Fragment>
                <NicheList niches={niches} onClick={() => this.showCatalog()} />
                <CatalogAbout />
              </React.Fragment>
            )
            : (
              <NicheCatalog
                latestBookTags={latestBookTags}
                latestBestAuthors={latestBestAuthors}
                niches={niches}
                bestsellersBookset={bestsellersBookset}
                latestBooksets={latestBooksets}
                booksCounter={booksPerSubscriptionCounter}
                audiobooks={audiobooks}
                onClick={() => this.showNicheList()} />
            )
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    catalogIndex: state.catalogIndex,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    CatalogIndexActions: bindActionCreators(CatalogIndexActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CatalogIndexView);
